<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('orgName')">
          <el-input
            v-model="queryForm.orgName"
            size="small"
            :placeholder="$t('orgName')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
          >
            <i class="el-icon-search" /> {{ $t("query") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column prop="name" width="200" :label="$t('orgName')" />
        <el-table-column
          prop="orgInfoCode"
          width="140"
          :label="$t('orgInfoCode')"
        />
        <el-table-column
          prop="linkPhone"
          width="160"
          :label="$t('linkPhone')"
        />
        <el-table-column width="200" :label="$t('orgLimitManaged')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.maxTradyLimit"
              style="color:#1164C4;font-weight:600"
            >
              FCFA {{ (scope.row.maxTradyLimit || 0).formatMoney(0) }}
            </span>
            <span v-else class="text-danger">{{ $t("notSet") }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('extend')" width="150">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="openEdit(scope.row)">
              {{ scope.row.maxTradyLimit ? $t("edit") : $t("define") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="
        editRow
          ? editRow.name + ' — ' + $t('orgLimitManaged')
          : $t('orgLimitManaged')
      "
      :visible.sync="drawer"
      direction="rtl"
      :size="400"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
    >
      <el-form
        :model="limitForm"
        :rules="rules"
        ref="limitForm"
        label-position="top"
        style="padding: 0 20px"
      >
        <el-form-item :label="$t('orgName')">
          <el-input
            :value="editRow ? editRow.name : ''"
            disabled
            size="medium"
          />
        </el-form-item>

        <el-form-item :label="$t('orgLimitManaged')" prop="maxTradyLimit">
          <el-input
            size="medium"
            v-model="limitForm.maxTradyLimit"
            type="tel"
            :placeholder="$t('orgLimitManaged')"
            @input="
              limitForm.maxTradyLimit = limitForm.maxTradyLimit
                .replace(/[^0-9]/g, '')
                .formatMoney(0, ' ')
            "
          >
            <template slot="prepend">FCFA</template>
          </el-input>
        </el-form-item>

        <el-alert
          v-if="editRow && editRow.maxTradyLimit"
          :title="
            $t('currentLimit') +
              ': FCFA ' +
              (editRow.maxTradyLimit || 0).formatMoney(0)
          "
          type="info"
          show-icon
          :closable="false"
          style="margin-bottom: 16px"
        />

        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isSubmitting"
            @click="submitLimit('limitForm')"
          >
            {{ $t("submit") }}
          </el-button>
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import org from "@/api/org";

export default {
  data() {
    return {
      queryForm: {},
      queryTableHeight: String,
      isLoading: false,
      tableData: {},
      pageSize: 20,
      currentPage: 1,

      drawer: false,
      editRow: null,
      limitForm: { maxTradyLimit: null },
      isSubmitting: false,
    };
  },
  computed: {
    rules() {
      return {
        maxTradyLimit: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value || parseInt(value) <= 0)
                callback(new Error(this.$t("requiredFields")));
              else callback();
            },
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList() {
      this.isLoading = true;
      org.getOrgInfoPage({
        param: {
          current: this.currentPage,
          size: this.pageSize,
          ...this.queryForm,
        },
        success: (res) => {
          this.tableData = res.data || {};
          this.isLoading = false;
        },
      });
    },
    openEdit(row) {
      this.editRow = row;
      this.limitForm = {
        maxTradyLimit: row.maxTradyLimit ? String(row.maxTradyLimit) : "",
      };
      this.drawer = true;
    },
    submitLimit(refName) {
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        this.isSubmitting = true;
        org.updateOrgLimit({
          param: {
            orgInfoId: this.editRow.id,
            maxTradyLimit: parseInt(
              String(this.limitForm.maxTradyLimit).replace(/\s/g, ""),
            ),
          },
          success: (res) => {
            this.isSubmitting = false;
            if (res.code == 200) {
              this.$message.success(this.$t("operateSuccessfully"));
              this.drawer = false;
              this.getList();
            } else {
              this.$message.warning(this.$t(res.msg));
            }
          },
        });
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.queryTableHeight = this.$refs.pageHead.offsetHeight + 15 + "px";
      this.getList();
    });
  },
};
</script>
